export const DEPARTMENT_DELETE_DIALOG = {
  TITLE: 'Delete Department',
  QUESTION: 'Are you sure you want to delete',
  CONFIRMATION: 'This action cannot be undone.',
  CANCEL: 'Cancel',
  DELETE: 'Delete',
}

export const DEPARTMENT_MESSAGES = {
  DELETED: 'Department deleted successfully',
  CREATED: 'Department created successfully',
  CREATED_WITHOUT_MEMBERS: 'Department created but failed to assign members',
  CREATED_WITHOUT_SUPPLIERS: 'Department created but failed to assign suppliers',
  FAILED_TO_CREATE: 'Failed to create department',
}

export const DEPARTMENTS = {
  TITLE: 'Departments',
  ADD_DEPARTMENT: 'Add Department',
  NO_DEPARTMENTS: 'No departments created yet.',
  MEMBERS: 'members',
  MEMBERS_COUNT: (count: number) => `Members (${count})`,
  NO_MEMBERS: 'No members',
  MORE_MEMBERS: 'more',
  DEPARTMENT_DETAILS: 'Department Details',
  DEPARTMENT_NAME: 'Department Name',
  NEW_DEPARTMENT: 'New Department',
  CREATE_DEPARTMENT: 'Create Department',
  CANCEL: 'Cancel',
  SELECT_MEMBERS: 'Select members...',
  ADD_MORE_MEMBERS: 'Add more members...',
  SEARCH_USERS: 'Search users...',
  LOADING: 'Loading...',
  NO_USERS_FOUND: 'No users found',
  SUPPLIERS: 'suppliers',
  SUPPLIERS_COUNT: (count: number) => `Suppliers (${count})`,
  SELECT_SUPPLIERS: 'Select suppliers...',
  ADD_MORE_SUPPLIERS: 'Add more suppliers...',
  SEARCH_SUPPLIERS: 'Search suppliers...',
  NO_SUPPLIERS_FOUND: 'No suppliers found',
}

export const EMPLOYEE_DASHBOARD_TABS = {
  TITLE: 'Employees Dashboard',
  EMPLOYEES: 'Employees',
}
